import React from 'react'
import { Row, Col } from 'reactstrap'
import moment from 'moment-timezone'
import JSONPretty from 'react-json-pretty'
import { Typography } from '@mui/material'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)

function FormattedRow({ f, m }) {
  const {
    field,
    added,
    removed,
    useremail,
    timestamp,
    parseError,
    userid,
    updated,
    be,
    mainChange,
  } = f
  if (parseError) {
    console.log('parseError b', be)
  }

  const formattedMainChanges = []
  if (mainChange && mainChange.main) {
    if (mainChange.formattedChanges) {
      for (let k of Object.keys(mainChange.formattedChanges)) {
        console.log(
          'mainChange.formattedChanges[k]',
          k,
          mainChange.formattedChanges[k]
        )
        for (let kl of Object.keys(mainChange.formattedChanges[k])) {
          const item = mainChange.formattedChanges[k][kl]
          console.log('item', item)
          formattedMainChanges.push(...item)
        }
      }
    }
  }

  return (
    <Row key={field}>
      <Col className='small' md={'2'}>
        {useremail ? useremail.replace('@', ' @') : userid}
      </Col>
      <Col className='small' md={'2'}>
        {dayjs(timestamp).format('D.M.YY HH:mm:ss')}
      </Col>
      {!parseError ? (
        <>
          <Col md={'2'}>
            <JSONPretty data={added}></JSONPretty>
          </Col>
          <Col md={'2'}>
            <JSONPretty data={updated}></JSONPretty>
          </Col>
          <Col md={'2'}>
            <JSONPretty data={removed}></JSONPretty>
          </Col>
          <Col md={'2'}>
            {mainChange.formattedChanges &&
              Object.keys(mainChange.formattedChanges).length > 0 ? (
              formattedMainChanges
            ) : (
              <JSONPretty data={mainChange}></JSONPretty>
            )}
          </Col>
        </>
      ) : (
        <>
          <Col md={'6'}>
            <code>{be}</code>
          </Col>
          <Col md={'3'}>
            <JSONPretty data={mainChange}></JSONPretty>
          </Col>
        </>
      )}
    </Row>
  )
}

function FormattedMainRow({ m }) {
  const { field, changes, useremail, timestamp, userid } = m

  console.log('changes', changes)
  return (
    <Row key={field} className='border-bottom'>
      <Col className='small' md={'4'}>
        {useremail ? useremail.replace('@', ' @') : userid}
      </Col>
      <Col className='small' md={'4'}>
        {dayjs(timestamp).format('D.M.YY HH:mm:ss')}
      </Col>
      <Col md={'4'}>
        {changes.map((c) => {
          // const key = Object.keys(c)[0]
          return <div>{c}</div>
        })}
      </Col>
    </Row>
  )
}

const MAIN_CHANGES = {
  create: { label: 'Luotu', main: true },
  cancelled: { label: 'Peruttu' },
  paymentadded: { label: 'Maksu lisätty' },
  onsale: { label: 'Laitettu myyntiin' },
  reserved: { label: 'Muutettu varatuksi' },
  sold: { label: 'Myyty' },
  partlysold: { label: 'Osittain myyty' },
  moved: { label: 'Siirretty' },
}

const KEYS = [
  { keys: ['state'], label: 'Varauksen tila' },
  { keys: ['payments'], label: 'Maksut' },
]

const MAIN_CHANGE_KEYS = [
  'state',
  'payments',
  'persons',
  'state',
  'isprereservation',
  'contractid',
  'recurrencyDates',
  'tags',
  'resourcegroups',
]

// const isMainChange = (keys) => {
//   for (let k of keys) {
//     if (MAIN_CHANGE_KEYS.includes(k)) {
//       return true
//     }
//   }
//   return false
// }

const formatPayments = (payments, reservation) => {
  if (!payments) return []
  // check if payments is array
  if (!Array.isArray(payments)) {
    // if not, check if it's an object with keys as ids
    if (typeof payments === 'object') {
      payments = Object.keys(payments).map((k) => payments[k])
    } else {
      return []
    }
  }

  return payments.map((p) => {
    return (
      <div>
        <Typography variant='body2'>
          {(p.amount / 100).toFixed(2) + ' €'} {p.typelabel}{' '}
        </Typography>
        <Typography variant='caption' component={'div'}>
          {p.occurency && reservation.isrecurring
            ? ' Vuoro: ' + dayjs(p.occurency).format('D.M.YY')
            : ''}
        </Typography>
        <Typography variant='caption'>
          {p.timestamp
            ? 'Maksuaika: ' +
            dayjs.utc(p.timestamp, 'YYYY.MM.DD HH:mm').local()
              .format('D.M.YY HH:mm:ss')
            : ''}
          <br />
          {p.note && p.note.length > 0 ? ' - ' + p.note : ''}
        </Typography>
      </div>
    )
  })
}

const hasOnlinePayment = (payments) => {
  if (!payments) return false
  if (!Array.isArray(payments)) {
    // if not, check if it's an object with keys as ids
    if (typeof payments === 'object') {
      payments = Object.keys(payments).map((k) => payments[k])
    } else {
      return false
    }
  }
  for (let p of payments) {
    if (p.type === 'online') {
      return true
    }
  }
  return false
}

const hasInvoicePayment = (payments) => {
  if (!payments) return false
  if (!Array.isArray(payments)) {
    // if not, check if it's an object with keys as ids
    if (typeof payments === 'object') {
      payments = Object.keys(payments).map((k) => payments[k])
    } else {
      return false
    }
  }
  for (let p of payments) {
    if (p.type === 'invoice') {
      return true
    }
  }
  return false
}

const hasSalestateChange = (recurrencyDates) => {
  if (!recurrencyDates) return false
  // check if recurrencyDates is array
  if (!Array.isArray(recurrencyDates)) {
    // if not, check if it's an object with keys as ids
    if (typeof recurrencyDates === 'object') {
      recurrencyDates = Object.keys(recurrencyDates).map((k) => {
        return { ...recurrencyDates[k], index: k }
      })
    } else {
      return false
    }
  }
  for (let r of recurrencyDates) {
    const changedKeys = Object.keys(r).filter((k) => k !== 'index')
    for (let ck of changedKeys) {
      if (ck === 'salestatus') {
        return true
      }
    }
  }
  return false
}

const formatRecurrencyChanges = (recurrencyDates, reservation) => {
  if (!recurrencyDates) return []
  // check if recurrencyDates is array
  if (!Array.isArray(recurrencyDates)) {
    // if not, check if it's an object with keys as ids
    if (typeof recurrencyDates === 'object') {
      recurrencyDates = Object.keys(recurrencyDates).map((k) => {
        return { ...recurrencyDates[k], index: k }
      })
    } else {
      return []
    }
  }

  return recurrencyDates.map((r) => {
    const changedKeys = Object.keys(r).filter((k) => k !== 'index')
    for (let ck of changedKeys) {
      const occurency = reservation.recurrencyDates
        ? reservation.recurrencyDates[parseInt(r.index)]
        : null
      if (ck === 'state') {
        const date = occurency ? dayjs(occurency.date).format('D.M.YY') : ''
        return (
          <Typography variant='caption' component={'div'}>
            Vuoron {date} tila muutettu
            tilaan:{' '}
            {MAIN_CHANGES[r.state] ? MAIN_CHANGES[r.state].label : r.state}
          </Typography>
        )
      } else if (ck === 'salestatus') {
        if (r && r.salestatus) {
          if (r.salestatus.p !== undefined && occurency) {
            return (
              <Typography variant='caption' component={'div'}>
                Vuorosta {dayjs(occurency.date).format('D.M.YY')} myyty: {(r.salestatus.p * 100).toFixed(1)}%
              </Typography>
            )
          }
        }
      } else {
        return null
      }
    }
  }).filter((c) => c !== null)
}

const isPrereservationChange = (diffObj) => {
  // diffobj.updated && diffObj.updated['isprereservation'] !== undefined && diffObj.updated['persons'] !== undefined
  if (diffObj.updated) {
    const isPrereservationChange =
      diffObj.updated['isprereservation'] !== undefined
    const personsChange = diffObj.updated['persons'] !== undefined
    if (isPrereservationChange && personsChange) {
      return {
        status: true,
        message: (
          <Typography variant='body2' style={{ fontWeight: 'bold' }}>
            Muutettu esivaraus varaukseksi
          </Typography>
        ),
      }
    }
  }
  return {
    status: false,
  }
}

const isReservationStateChange = (diffObj) => {
  // diffObj.updated && diffObj.updated['state'] !== undefined
  if (diffObj.updated) {
    const stateChange = diffObj.updated['state'] !== undefined
    if (stateChange) {
      return {
        status: true,
        message: [
          <Typography variant='body2' style={{ fontWeight: 'bold' }}>
            Varauksen tilan muutos
          </Typography>,
          MAIN_CHANGES[diffObj.updated['state']]
            ? MAIN_CHANGES[diffObj.updated['state']].label
            : diffObj.updated['state'],
        ],
      }
    }
  }
  return {
    status: false,
  }
}

const isRecurrentStateChange = (diffObj, reservation) => {
  // diffObj.updated && diffObj.updated['recurrencyDates'] !== undefined
  if (diffObj.updated) {
    const recurrentDatesChange =
      diffObj.updated['recurrencyDates'] !== undefined
    if (recurrentDatesChange) {
      const message = [
        <Typography variant='body2' style={{ fontWeight: 'bold' }}>
          Vakiovuoron vuoron muutos:
        </Typography>,
        ...formatRecurrencyChanges(
          diffObj.updated['recurrencyDates'],
          reservation
        ),
      ]
      return {
        status: true,
        message,
        ignorechanger: hasSalestateChange(diffObj.updated['recurrencyDates']),
      }
    }
  }
  return {
    status: false,
  }
}

const isPaymentChange = (diffObj, reservation) => {
  // diffObj.added && diffObj.added['payments'] !== undefined
  if (diffObj.added) {
    const paymentAdded = diffObj.added['payments'] !== undefined
    if (paymentAdded) {
      const message = [
        <Typography variant='body2' style={{ fontWeight: 'bold' }}>
          Maksulisäys
        </Typography>,
        ...formatPayments(diffObj.added['payments'], reservation),
      ]
      return {
        status: true,
        message,
        ignorechanger:
          reservation &&
          reservation.isrecurring &&
          (hasOnlinePayment(diffObj.added['payments']) ||
            hasInvoicePayment(diffObj.added['payments'])),
      }
    }
  }
  return {
    status: false,
    message: JSON.stringify(diffObj, null, 2),
  }
}

const isPayerChange = (diffObj, before, after) => {
  // diffObj.updated && diffObj.updated['persons'] !== undefined && diffObj.updated['persons'].payers !== undefined
  if (diffObj.updated && diffObj.updated['persons'] !== undefined) {
    const payersChange = diffObj.updated['persons'].payers !== undefined
    if (payersChange) {
      const beforePayers =
        before &&
          before.persons &&
          before.persons.payers &&
          before.persons.payers['0']
          ? {
            firstname: before.persons.payers['0'].firstname,
            lastname: before.persons.payers['0'].lastname,
            email: before.persons.payers['0'].email,
            name: before.persons.payers['0'].name,
          }
          : null
      const afterPayers =
        after &&
          after.persons &&
          after.persons.payers &&
          after.persons.payers['0']
          ? {
            firstname: after.persons.payers['0'].firstname,
            lastname: after.persons.payers['0'].lastname,
            email: after.persons.payers['0'].email,
            name: after.persons.payers['0'].name,
          }
          : null

      if (beforePayers || afterPayers) {
        const isBeforeOrganisation =
          beforePayers && beforePayers.name && beforePayers.name.length > 0
        const isAfterOrganisation =
          afterPayers && afterPayers.name && afterPayers.name.length > 0
        const beforeLabel = isBeforeOrganisation
          ? beforePayers.name
          : beforePayers
            ? beforePayers.firstname +
            ' ' +
            beforePayers.lastname +
            ' (' +
            beforePayers.email +
            ')'
            : 'tuntematon'
        const afterLabel = isAfterOrganisation
          ? afterPayers.name
          : afterPayers
            ? afterPayers.firstname +
            ' ' +
            afterPayers.lastname +
            ' (' +
            afterPayers.email +
            ')'
            : 'tuntematon'

        return {
          status: true,
          message: [
            <Typography variant='body2' style={{ fontWeight: 'bold' }}>
              Maksajan muutos
            </Typography>,
            <div>
              {beforeLabel} → {afterLabel}
            </div>,
          ],
        }
      }
    }
  }
  return {
    status: false,
    message: JSON.stringify(diffObj, null, 2),
  }
}

const isResourceChange = (diffObj, before) => {
  // diffObj.updated && diffObj.updated['resourcegroups'] !== undefined
  if (diffObj.updated) {
    const resourceGroupsChange = diffObj.updated['resourcegroups'] !== undefined
    if (resourceGroupsChange) {
      // check if only property 0 resources exists
      const rgKeys = Object.keys(diffObj.updated['resourcegroups'])
      if (rgKeys.length === 1 && rgKeys[0] === '0') {
        const rgChange = diffObj.updated['resourcegroups']['0'].resources
        // if rgChange has property 0 which has displayName property
        if (
          rgChange &&
          rgChange['0'] &&
          rgChange['0'].displayName !== undefined
        ) {
          const resourceBefore =
            before &&
              before.resourcegroups &&
              before.resourcegroups['0'] &&
              before.resourcegroups['0'].resources &&
              before.resourcegroups['0'].resources['0']
              ? before.resourcegroups['0'].resources['0'].displayName
              : 'tuntematon'
          return {
            status: true,
            message: [
              <Typography variant='body2' style={{ fontWeight: 'bold' }}>
                Resurssin muutos
              </Typography>,
              <div>
                {resourceBefore} → {rgChange['0'].displayName}
              </div>,
            ],
          }
        }
      }
    }
  }

  return {
    status: false,
    message: JSON.stringify(diffObj, null, 2),
  }
}

const isPriceChange = (diffObj, before) => {
  // diffObj.updated && diffObj.updated['resourcegroups'] !== undefined
  if (diffObj.updated && diffObj.updated['resourcegroups'] !== undefined) {
    // check if property 0 cost is changed
    const resourceGroupsChange = Object.keys(diffObj.updated['resourcegroups'])
      .map((k) => {
        const rgChange = diffObj.updated['resourcegroups'][k]
        if (rgChange && rgChange.cost !== undefined) {
          return rgChange.cost
        } else if (rgChange && rgChange.overridecost !== undefined) {
          return rgChange.overridecost
        } else {
          return null
        }
      })
      .filter((c) => c !== null)
    if (resourceGroupsChange.length === 1) {
      const costBefore =
        before && before.resourcegroups && before.resourcegroups['0']
          ? before.resourcegroups['0'].cost
          : null
      const overridecostBefore =
        before && before.resourcegroups && before.resourcegroups['0']
          ? before.resourcegroups['0'].overridecost
          : null
      let beforeCost =
        overridecostBefore !== null && overridecostBefore !== undefined
          ? overridecostBefore
          : costBefore
      if (beforeCost === null || beforeCost === undefined || isNaN(beforeCost) || beforeCost.length === 0) {
        beforeCost = 0
      }
      if (typeof beforeCost === 'string') {
        beforeCost = parseFloat(beforeCost)
      }
      console.log('beforeCost', beforeCost, 'resourceGroupsChange', resourceGroupsChange)
      if (typeof resourceGroupsChange[0] === 'string') {
        resourceGroupsChange[0] = parseFloat(resourceGroupsChange[0])
      }
      return {
        status: true,
        message: [
          <Typography variant='body2' style={{ fontWeight: 'bold' }}>
            Hinnan muutos
          </Typography>,
          beforeCost.toFixed(2) +
          ' €' +
          ' → ' +
          resourceGroupsChange[0].toFixed(2) +
          ' €',
        ],
      }
    }
  }

  return {
    status: false,
    message: JSON.stringify(diffObj, null, 2),
  }
}

const isContractChange = (diffObj) => {
  // diffObj.added && diffObj.added['contractid'] !== undefined
  if (diffObj.added) {
    const contractAdded = diffObj.added['contractid'] !== undefined
    if (contractAdded) {
      return {
        status: true,
        message: (
          <Typography variant='body2' style={{ fontWeight: 'bold' }}>
            Sopimus lisätty
          </Typography>
        ),
      }
    }
  }
  return {
    status: false,
  }
}

const isTagChange = (diffObj) => {
  // diffObj.added && diffObj.added['tags'] !== undefined
  const message = []
  if (diffObj.added) {
    const tagsAdded = diffObj.added['tags'] !== undefined
    if (tagsAdded) {
      const addedTags = Object.keys(diffObj.added['tags'])
        .map((k) => diffObj.added['tags'][k])
        .join(', ')
      message.push([
        <Typography variant='body2' style={{ fontWeight: 'bold' }}>
          Tagi lisäys
        </Typography>,
        <Typography variant='body2'>{addedTags}</Typography>,
      ])
    }
  }
  if (diffObj.updated) {
    const tagsUpdated = diffObj.updated['tags'] !== undefined
    if (tagsUpdated) {
      message.push(
        <Typography variant='body2' style={{ fontWeight: 'bold' }}>
          Tagi päivitetty
        </Typography>
      )
    }
  }
  if (message.length > 0) {
    return {
      status: true,
      message,
    }
  }
  return {
    status: false,
  }
}

const getChangesFormatted = (diffObj, reservation, before, after) => {
  console.log('getChangesFormatted diffObj', diffObj)
  const changes = [
    isPrereservationChange(diffObj),
    isReservationStateChange(diffObj),
    isRecurrentStateChange(diffObj, reservation),
    isPaymentChange(diffObj, reservation),
    isPayerChange(diffObj, before, after),
    isResourceChange(diffObj, before),
    isPriceChange(diffObj, before),
    isContractChange(diffObj),
    isTagChange(diffObj, before),
  ].filter((c) => c.status)
  if (changes.length === 0) {
    const _m = { message: <pre>{JSON.stringify(diffObj, null, 2)}</pre> }
    if (diffObj.updated && !hasSalestateChange(diffObj.updated['recurrencyDates'])) {
      changes.push(_m)
    }
  }
  return changes

  // const addedChanges = []
  // const updateChanges = []
  // const mainAddedKeys = Object.keys(diffObj.added )
  // if (diffObj.added) {
  //   if (mainKey === 'payments') {
  //     console.log('diffObj.added[mainKey]', diffObj.added[mainKey])
  //     changes.push(<div>Lisätty maksu(t):</div>)
  //     changes.push(...formatPayments(diffObj.added[mainKey], reservation))
  //   } else if (mainKey === 'persons') {
  //     // check updated persons if there is empty isprereservation
  //     diffObj.updated = diffObj.updated || {}
  //     const isPrereservationChange = diffObj.updated['isprereservation'] !== undefined
  //     if (isPrereservationChange) {
  //       changes.push(
  //         <div>
  //           Muutettu esivaraus varaukseksi
  //           <pre>{JSON.stringify(diffObj.updated)}</pre>
  //         </div>
  //       )
  //     }
  //   // } else if (mainKey === 'state') {
  //   //   changes.push(
  //   //     <div>Muutettu tilaan</div>
  //   //   )
  //   }
  //   else {
  //     changes.push(diffObj.added)
  //   }
  // }
  // return changes
}

const recognizeChangeType = (diff, type, reservation) => {
  console.log('recognizeChangeType diff, type', diff, type)
  if (type === 'create') {
    return MAIN_CHANGES['create']
  } else if (type === 'update') {
    const d = JSON.parse(diff)
    let addedkeys = Object.keys(d.added || {})
    let removedkeys = Object.keys(d.deleted || {})
    let updatedkeys = Object.keys(d.updated || {})
    const addedMain = addedkeys.filter((k) => MAIN_CHANGE_KEYS.includes(k))
    const removedMain = removedkeys.filter((k) => MAIN_CHANGE_KEYS.includes(k))
    const updatedMain = updatedkeys.filter((k) => MAIN_CHANGE_KEYS.includes(k))
    const l = { main: false, labels: [], details: {}, formattedChanges: {} }
    if (addedMain.length > 0) {
      l.labels.push('Lisäys')
      l.main = true
      l.details.addedkeys = addedMain
      // l.formattedChanges.added = {}
      // for (let k of addedMain) {
      //   l.formattedChanges.added[k] = getChangesFormatted(d, k, reservation)
      // }
    }
    if (removedMain.length > 0) {
      l.labels.push('Poisto')
      l.main = true
      l.details.removedkeys = removedMain
    }
    if (updatedMain.length > 0) {
      l.labels.push('Päivitys')
      l.main = true
      l.details.updatedkeys = updatedMain
    }
    if (l.labels.length > 0) {
      return l
    }
  }
  return { label: 'Tuntematon', main: false }
}

function ReservationChanges({ reservation, diffs }) {
  if (!diffs || Object.keys(diffs).length === 0) {
    return null
  }
  console.log('diffs', diffs)
  const mainChanges = Object.keys(diffs)
    .map((key) => {
      const o = diffs[key]
      const mainChange = recognizeChangeType(o.diff, o.type, reservation)
      return { key, o, mainChange }
    })
    .filter((mc) => mc.mainChange.main)
    .map((m) => {
      const f = []
      let ignorechanger = false
      console.log('m', m)
      if (m.o.type === 'create') {
        f.push(<div>Luotu</div>)
      }
      if (m.mainChange && m.mainChange.details) {
        const mc = m.mainChange
        console.log('mc', mc)
        const fo = getChangesFormatted(
          JSON.parse(m.o.diff),
          reservation,
          JSON.parse(m.o.before),
          JSON.parse(m.o.after)
        )
        ignorechanger = fo.find((c) => c.ignorechanger)
        f.push(...fo.map((c) => c.message))
      }
      if (f.length > 0) {
        return {
          field: m.key,
          useremail: ignorechanger ? '' : m.o.useremail,
          timestamp: m.o.timestamp,
          userid: ignorechanger ? '' : m.o.userid,
          changes: f,
        }
      } else {
        return null
      }
    }).filter((mc) => mc !== null)
  console.log('mainChanges', mainChanges)

  // const formattedDiffs = Object.keys(diffs).map((key) => {
  //   const o = diffs[key]
  //   const mainChange = recognizeChangeType(o.diff, o.type, reservation)
  //   let parseError = false
  //   let b = null
  //   try {
  //     b = JSON.parse(o.diff)
  //   } catch (e) {
  //     b = o.diff
  //     parseError = true
  //   }
  //   return {
  //     parseError,
  //     useremail: o.useremail,
  //     timestamp: o.timestamp,
  //     field: key,
  //     userid: o.userid,
  //     be: b,
  //     added: parseError ? null : b.added,
  //     removed: parseError ? null : b.deleted,
  //     updated: parseError ? null : b.updated,
  //     mainChange,
  //   }
  // })
  // console.log('formattedDiffs', formattedDiffs)
  return (
    <div>
      <Row>
        <Col>
          <Row className='border-bottom font-weight-bold'>
            <Col md={'4'}>Käyttäjä</Col>
            <Col md={'4'}>Aika (Suomen aikaa)</Col>
            <Col md={'4'}>Muutokset</Col>
          </Row>
          {mainChanges.map((f) => (
            <FormattedMainRow m={f} />
          ))}
        </Col>
      </Row>
    </div>
  )
}

export default ReservationChanges
